'use strict';
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { builderDispatch } from '../_utils/ui';
import Events from './flux-events';

// -----------------------------------------------------------
//  Search
// -----------------------------------------------------------
const Search = ({ defaultTerm, categoryName, onChange }) => {
  const searchRef = useRef(null);
  useEffect(() => {
    const builderDispatchToken = builderDispatch.register(payload => {
      if (payload.type === Events.SEARCH_CLEARED) {
        searchRef.current.value = '';
      }
    });

    return () => {
      builderDispatch.unregister(builderDispatchToken);
    };
  }, []);

  const handleSubmit = e => {
    e.preventDefault();
    onChange(searchRef.current.value);
  };

  const handleClear = () => {
    searchRef.current.value = '';
    onChange('');
  };

  return (
    <div>
      <div className="ml-1 search-wrapper">
        <form
          className="input-group search-group"
          onSubmit={handleSubmit}
          id="search">
          <label htmlFor="search" className="d-none">Search</label>
          <input
            className="search-input p-3 h-100"
            ref={searchRef}
            name="search"
            id="search"
            type="search"
            defaultValue={defaultTerm}
            placeholder={`Search ${categoryName}`}
            aria-label={`Search ${categoryName}`}
          />
          <button
            className="btn fa fa-search p-2 h-100 search-button"
            type="submit"
            aria-label="search"
          />
          <button
            className={classNames('btn btn-link p-2 m-2', {
              'clear-button': true,
              'd-none': defaultTerm === '',
            })}
            onClick={handleClear}
            aria-label="clear search">
            Clear Search
          </button>
        </form>
      </div>
    </div>
  );
};

Search.propTypes = {
  defaultTerm: PropTypes.string,
  onChange: PropTypes.func,
  categoryName: PropTypes.string,
};

export default Search;
